// extracted by mini-css-extract-plugin
export var dropdownArrow__icon = "Footer-module--dropdownArrow__icon--32c73";
export var focus = "Footer-module--focus--e4ae3";
export var footer = "Footer-module--footer--2d913";
export var footer__container = "Footer-module--footer__container--463ac";
export var footer__details = "Footer-module--footer__details--d77fa";
export var footer__header = "Footer-module--footer__header--67e05";
export var footer__link = "Footer-module--footer__link--baf74";
export var footer__linkList = "Footer-module--footer__linkList--66bc5";
export var footer__links = "Footer-module--footer__links--a172c";
export var footer__listWrap = "Footer-module--footer__listWrap--b12f1";
export var footer__locationCollection = "Footer-module--footer__locationCollection--c858e";
export var footer__locationMap = "Footer-module--footer__locationMap--072b8";
export var footer__locations = "Footer-module--footer__locations--2aea2";
export var footer__locationsContainer = "Footer-module--footer__locationsContainer--1d477";
export var footer__logo = "Footer-module--footer__logo--1d930";
export var footer__map = "Footer-module--footer__map--80048";
export var footer__mobileLink = "Footer-module--footer__mobileLink--11e64";
export var footer__socialMedia = "Footer-module--footer__socialMedia--48a33";
export var footer__socialMediaWrap = "Footer-module--footer__socialMediaWrap--43132";
export var footer__trim = "Footer-module--footer__trim--adc4b";
export var placeholderLocation = "Footer-module--placeholderLocation--83680";
export var qualityStatement = "Footer-module--qualityStatement--0dd8f";
export var rightsReserved = "Footer-module--rightsReserved--01f03";
export var siteMap = "Footer-module--siteMap--8dcd4";